import React from 'react';
import Logo from '../../assets/erpsaude.png';

export default function HospitalError({
  hospital,
  title = 'Unidade nao encontrada',
  message,
  hint = 'Verifique o endereco informado ou entre em contato com o suporte tecnico.',
}) {
  const resolvedMessage =
    message || `A unidade "${hospital}" nao foi reconhecida pelo sistema.`;

  return (
    <div className="error-container">
      <img src={Logo} alt="ERPSaude" className="error-logo" />
      <div className="error-content">
        <h1 className="error-title">{title}</h1>
        {hospital && <p className="error-message">{resolvedMessage}</p>}
        <p className="error-hint">{hint}</p>
      </div>
    </div>
  );
}
